<form #form="ngForm" autocomplete="off">
    <mat-form-field>
        <mat-label>{{ timeOffRequestDay.shortDateString | i18nDate: 'shortSeparatedNoYear' }}</mat-label>
        <input
            #timeOffRequestDayInput
            type="text"
            min="0"
            [max]="maxAmount"
            matInput
            name="timeOffRequestDayAmount"
            #timeOffRequestDayAmount="ngModel"
            [ngModel]="getFormattedRequestDayAmount(timeOffRequestDay.amount)"
            [ngModelOptions]="{ updateOn: 'blur' }"
            (ngModelChange)="setFormattedRequestDayAmount($event)"
            required
        />
        <mat-error *ngIf="timeOffRequestDayAmount.invalid">{{
            'time-off-v3.theAmountPerDayShouldBeBetween' | translate: { max: maxAmount }
        }}</mat-error>
    </mat-form-field>
    <ui-info text="{{ 'time-off-v3.ifBookingLessThanAFullDayAwayEditTheValueHere' | translate }}"></ui-info>
</form>
